// extracted by mini-css-extract-plugin
export default {"status-group":"client-status-group_status-group__byip0","icon":"client-status-group_icon__TeZuS"};